// extracted by mini-css-extract-plugin
export default {"no-background":"SuggestedFriendList--no-background--gJP-V","noBackground":"SuggestedFriendList--no-background--gJP-V"};